import React from 'react'
import EmiCalulator from '../PersonalLoanEmiCalc/emiCalulator'
import EmiCalculatorImage from "../../assets/images/stashfin-emi-calculator.webp"
import "../PersonalLoanEmiCalc/personalLoan.scss"
import { useSelector } from 'react-redux'

const LoanEmiCalculator = () => {
  const { cityData } = useSelector(state => state.CityWiseIplReducer)
  return (
    <section id="emiCalculator" className='personalEmiCalc'>
      <div className='heading'>
        EMI calculator for Stashfin <br /> personal loans in {cityData?.city}
      </div>
      <div className='emi-calc-container'>
        <img src={EmiCalculatorImage} alt="Emi calculator | Satshfin" loading='lazy' />
        <div className='emi-calc-heading'>
          Personal Loan <br /> Eligibility Calculator
        </div>
        <div className='emi-calc-content'>
          If you are new to Stashfin, you need to download the Stashfin mobile app on your smartphone, launch the app and click on the 'Get Personal Loan' link on the login page.
        </div>
      </div>
      <EmiCalulator />
    </section>
  )
}
export default LoanEmiCalculator
